import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import AetherLogo from "../../assets/img/aether.png"
import ImageRetrieval from "../ImageRetrieval";
import { AuthContext } from "../../common/Auth"
import { useThemeSettings } from "../../layouts/state/useThemeSettings";
import LogoAndStoreName from "../header/LogoChange";
import useWindowSize from "../../util/custom-hooks/useWindowSize";

const FooterCopyright = ({ spaceBottomClass, colorClass, menuStyleData }) => {

  const { settingData } = useContext(AuthContext)
  const { storeName } = useThemeSettings({settingData})
  const [windowWidth] = useWindowSize()
  const [isSmallScreen, setIsSmallScreen] = useState(windowWidth < 992);
  useEffect(() => {
    if (windowWidth < 992) {
      setIsSmallScreen(true);
      return;
    }
    setIsSmallScreen(false);
  }, [windowWidth]);

  let fontStyle = {
    fontFamily: menuStyleData && menuStyleData.menuFont,
    color: menuStyleData && menuStyleData.menuFontcolor,
    width: (menuStyleData.logoWidth > 300 || (menuStyleData.logoWidth < 501 && menuStyleData.logoWidth >= 600)) && isSmallScreen ? '100%' : "max-content"
  }

  return (

    <div
      style={fontStyle}
      className={`copyright ${spaceBottomClass ? spaceBottomClass : ""} ${colorClass ? colorClass : ""} text-center `}
    >
      {menuStyleData && menuStyleData.showLogo && <div className="footer-logo">
        <Link to={process.env.PUBLIC_URL + "/"}>
          <div>
            <LogoAndStoreName footerlogoWidth={menuStyleData.logoWidth} menuStyleData = {menuStyleData} />
            {/* <ImageRetrieval footerlogoWidth={menuStyleData.logoWidth} className="" />
            <h3 style={fontStyle}>{storeName.length > 0 ? storeName.toString() : ""} </h3> */}
          </div>
        </Link>
      </div>}

      {menuStyleData.copyYear !== undefined && menuStyleData.copyYear !== "undefined" && menuStyleData.copyYear !== "" ? "©" + menuStyleData.copyYear + " " : " "}
      <a className={`${colorClass ? colorClass : ''}`} href={menuStyleData.linkPoweredBy !== undefined && menuStyleData.linkPoweredBy !== "undefined" && menuStyleData.linkPoweredBy !== "" ? menuStyleData.linkPoweredBy :"https://anterasoftware.com/"} rel="noopener noreferrer" target="_blank" style={fontStyle}>
        {menuStyleData.poweredBy !== undefined && menuStyleData.poweredBy !== "undefined" && menuStyleData.poweredBy !== "" ? menuStyleData.poweredBy : ""}
      </a>
      <br />{menuStyleData.text !== undefined && menuStyleData.text !== "" && menuStyleData.text !== "undefined" ? menuStyleData.text : ""}
    </div>
  );
};

export default FooterCopyright;
